<template>
    <div>
        <b-modal v-model="isModalVisible" id="message-modal" hide-footer :close-on-backdrop="false" class="pt-8" centered
            header-class="p-0" footer-class="d-flex justify-content-center border-0" content-class="custom-model-wrap">
            <template #modal-title>
                <div class="title-block text-center p-2">
                    {{ model.hash ? $translate('view_message') : $translate('add_message') }}
                </div>
            </template>
            <div v-if="!!model.id">
                <label class="mb-2"><strong>{{ $translate('received') }}</strong></label><br>
                {{ model.created_at | displayTime }}
            </div>
            <div class="mt-3" v-if="!!model.id">
                <label class="mb-2"><strong>{{ $translate('sender') }}</strong></label><br>
                {{ displayUser(model.user) }} 
            </div>
            <div class="my-3">
                <label class="mb-3" for="input-activity-message"><strong>{{ $translate('message') }}</strong></label>
                <textarea-with-audio 
                    v-model="model.content" 
                    :idAttr="'input-activity-message'"
                    :placeholderAttr="$translate('enter_message')" 
                    :rows="6" 
                    :maxRows="10"
                    @update:content="handleContentUpdate"
                    :disabledAttr="(viewMode && !isNew)"
                    :value="model.content"
                    
                />
            </div>
            <div class="d-flex justify-content-center">
                <b-button v-show="!model.id || (model.user_id == user.id)" size="sm" @click="createMessage" class="btn-fw me-3" v-if="hasPermissionCreate"
                    :disabled="(submitting ? true : false) || (viewMode && !isNew)" variant="info">{{ model.hash
                        ? $translate('update_message') : $translate('add_message') }}</b-button>
                <b-button size="sm" @click="isModalVisible = false" variant="info" class="btn-fw">{{ $translate('close')
                }}</b-button>
            </div>
        </b-modal>
        <div class="d-flex align-items-center justify-content-end">
            <span class="me-2">{{ $translate('add_message') }}</span>
            <div class="Click-here"></div>
            <b-button variant="blue-icon" :disabled="viewMode && !isNew" v-if="hasPermissionCreate" @click=" 
                model.content = ''
            model.hash = ''
            model.id = null
            isModalVisible = true
                " v-b-tooltip.hover :title="$addLabel()"><img src="@/assets/images/icon/gradient-add.svg"></b-button>
        </div>
        <b-table id="orderTable" :items="messages" :fields="fields" :busy="tableLoading" responsive show-empty
            ref="selectableTable">
            <template #table-busy>
                <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <!-- <strong>{{ $translate('loading') }}</strong> -->
                </div>
            </template>

            <template #empty>
                <p class="text-center m-0">{{ $translate("add_message_note") }}</p>
            </template>
            <template #emptyfiltered>
                <p class="text-center m-0">{{ $translate("add_message_note") }}</p>
            </template>

            <template #cell(actions)="{ item }">
                <div class="d-flex">
                    <b-button v-if="hasPermissionView" @click="viewNote(item)" class="me-2" variant="pink-button">
                        <img src="@/assets/images/icon/view.svg">
                    </b-button>
                    <b-button variant="pink-button" v-if="hasPermissionDelete && order.completed != 1"
                        @click="deleteMessage(item.hash)"
                        :disabled="(viewMode && !isNew) || (submitting ? true : false)"><img
                            src="@/assets/images/icon/delete.svg"></b-button>
                </div>
            </template>

            <template #cell(id)="{ index }">
                <p>
                    {{ index + 1 }}
                </p>
            </template>

            <template #cell(content)="{ value }">
                <p>
                    {{ value }}
                </p>
            </template>

            <template #cell(created_at)="{ value }">
                <p>{{ value | displayTime(new Date()) }}</p>
            </template>

            <template #cell(user_id)="{ item }">
                <p>
                    {{ displayUser(item.user) }}
                </p>
            </template>
        </b-table>
    </div>
</template>

<script>
// import moment from 'moment'
import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'
import TextareaWithAudio from '@/components/TextareaWithAudio.vue'

export default {
    name: 'orders-notes',
    mixins: [popupMixins, permissionsMixins],
    components: {'textarea-with-audio': TextareaWithAudio},
    data() {
        return {
            model: {},
            isModalVisible: false,
            messageCreated: false,
            tableLoading: false,
            submitting: false,
        }
    },
    props: {
        viewMode: { type: Boolean, default: false },
        isNew: { type: Boolean, default: false },
    },
    filters: {
        displayTime(date) {
            const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
            console.log('timezone', timezone)
            if (date) {
                return new Date(date).toLocaleString('en-US', {
                    timeZone: timezone,
                })
            } else {
                return ''
            }
        },
    },
    computed: {
        componentName() { return this.$translate('message') },
        fields() {
            return [
                {
                    key: 'id',
                    label: '',
                    class: 'id_class',
                },
                {
                    key: 'actions',
                    label: this.$translate('actions'),
                    class: 'actionButton_class',
                },
                {
                    key: 'user_id',
                    label: this.$translate('sender'),
                    class: 'user_id_class',
                },
                {
                    key: 'content',
                    label: this.$translate('messages'),
                    class: 'text-left text-wrap',
                },

                {
                    key: 'created_at',
                    label: this.$translate('received'),
                    class: 'created_at_class',
                },
               
            ]
        },
        order() {
            return this.$store.state.orders.item
        },

        user() {
            const _user = this.$store.state.user;
            console.log("user-----------", _user);
            return _user;
        },

        orderNotes() {
            return this.$store.state.orders.notes
        },
        messages() {
            const messages = this.$store.state.orderMessagesStore.messages
            console.log('message -- ', messages)
            return messages
        },
    },
    watch: {
        'orderNotes': {
            handler: function (messages) {
                this.$store.dispatch('orderMessagesStore/load', messages)
            },
            deep: true,
        },
    },
    mounted() {
        // const { notes } = this.order
        const notes = this.orderNotes
        this.messageCreated = false
        this.$store.dispatch('orderMessagesStore/load', notes || [])
    },
    methods: {
        displayUser(user) {
            if (user) {
                const name = user.first_name + ' ' + user.last_name
                return (user.is_customer_user ? this.$translate('client') : this.$translate('agent')) + ':' + name
            } else {
                return this.$translate('self')
            }
        },
        viewNote(item) {
          
            this.model = { ...item }
          
            for (const key in item) {
                console.log('item is---',item[key]);
                this.$set(this.model, key, item[key])
            }
            this.isModalVisible = true
        },
        formatDate(date) {
            var hours = date.getHours()
            var minutes = date.getMinutes()
            var ampm = hours >= 12 ? 'pm' : 'am'
            hours = hours % 12
            hours = hours ? hours : 12 // the hour '0' should be '12'
            minutes = minutes < 10 ? '0' + minutes : minutes
            var strTime = hours + ':' + minutes + ' ' + ampm
            return (
                date.getMonth() +
                1 +
                '/' +
                date.getDate() +
                '/' +
                date.getFullYear() +
                '  ' +
                strTime
            )
        },

        createMessage() {
        console.log('create message',this.model.content);
            const {
                model: { content, hash },
            } = this
            const message = { content, hash }
            this.$store.dispatch('orderMessagesStore/merge', message)
            this.genericToast(
                this.componentName,
                this.$translate('created'),
                'success',
                `${this.componentName} ${this.$translate('save_alert')}`
            )
            this.isModalVisible = false
            this.messageCreated = true
            this.$emit('addMessage', 1);
        },
        deleteMessage(hash) {
            this.$store.dispatch('orderMessagesStore/delete', hash)
            this.genericToast(
                this.componentName,
                this.$translate('deleted'),
                'success',
                `${this.componentName} ${this.$translate('delete_alert')}`
            )
            this.$emit('success', this.componentName, this.$translate('deleted'))
        },
        handleContentUpdate(newValue) {
          
            // Set the value of model.content
            this.model.content = newValue;

         
        }
    },
}
</script>

<style>
.text-wrap {
    white-space: normal !important;
}

.created_at_class,
.user_id_class {
    width: 20% !important;
}

.id_class {
    width: 2% !important;
}

.actionButton_class {
    width: 8% !important;
}
</style>
